import { render, staticRenderFns } from "./HistoricPDF.vue?vue&type=template&id=309ef92d&scoped=true&"
import script from "./HistoricPDF.vue?vue&type=script&lang=ts&"
export * from "./HistoricPDF.vue?vue&type=script&lang=ts&"
import style0 from "./HistoricPDF.vue?vue&type=style&index=0&id=309ef92d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "309ef92d",
  null
  
)

export default component.exports